// extracted by mini-css-extract-plugin
export default {"social":"styles_social__Ioxds","phone":"styles_phone__ct4Qq"};